import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ProductService {

  constructor(private  http:HttpClient) { }

  getProducts() {
    return this.http.get('http://www.api.playit.mobi/api/v2/Android/products').map(result => result);
  }
  getpkgProducts(pkgName) {
    return this.http.get('http://www.api.playit.mobi/api/v2/Android/products/package?packageName=${pkgName}').map(result => result);

  }
  addProduct(data) {
    return this.http.post(`http://www.api.playit.mobi/api/v2/Android/products`, data).map(result => result);
  }
  editProduct(id,data) {
    return this.http.post(`http://www.api.playit.mobi/api/v2/Android/products/${id}`, data).map(result => result);

  }
  deleteProduct(id) {
    return this.http.delete(`http://www.api.playit.mobi/api/v2/Android/products/${id}`).map(result => result);
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/Services/product.service.ts